import moment from 'moment'

export default {
	filter: function(date, format){
        return moment(date).format(format)
	}
};
